export enum FeatureAccessType {
  PUBLIC_API = "PUBLIC_API",
  RESOURCE_BOOKING = "RESOURCE_BOOKING",
  RESOURCE_BOOKING_GEOFENCING_CHECKIN = "RESOURCE_BOOKING_GEOFENCING_CHECKIN",
  ROOMS = "ROOMS",
  SERVICE_REQUESTS = "SERVICE_REQUESTS",
  SERVICE_REQUESTS_FOR_ROOMS = "SERVICE_REQUESTS_FOR_ROOMS",
  ROOMS_PRIORITY_ACCESS = "ROOMS_PRIORITY_ACCESS",
  SCHEDULING = "SCHEDULING",
  OFFICE_EVENTS = "OFFICE_EVENTS",
  HYBRID_WORK_POLICIES = "HYBRID_WORK_POLICIES",
  WORKFORCE_ANALYTICS = "WORKFORCE_ANALYTICS",
  SCHEDULING_CALENDAR_SYNC = "SCHEDULING_CALENDAR_SYNC",
  SCHEDULING_HRIS_SYNC = "SCHEDULING_HRIS_SYNC",
  MANAGER_VALIDATION = "WORKFORCE_MANAGER_VALIDATION",
  OFFICE_ROLES = "OFFICE_ROLES",
  OFFICE_ROLES_USER_EDITING = "OFFICE_ROLES_USER_EDITING",
  HRIS = "HRIS",
  GLOBAL_TRACKING_OPT_OUT = "GLOBAL_TRACKING_OPT_OUT",
}

export enum FeatureQuotaType {
  HYBRID_WORK_POLICIES = "HYBRID_WORK_POLICIES",
  MANAGER_VALIDATION = "MANAGER_VALIDATION",
  OFFICE_ROLES_TOTAL_ASSIGNMENTS = "OFFICE_ROLES_TOTAL_ASSIGNMENTS",
  ROOMS_WITH_SERVICES = "ROOMS_WITH_SERVICES",
  ROOMS_WITH_KIOSK = "ROOMS_WITH_KIOSK",
  ACTIVE_OFFICE_EVENTS = "ACTIVE_OFFICE_EVENTS",
  HRIS_SYNC = "HRIS_SYNC",
  ROOMS = "ROOMS",
}
